import { useSelector } from 'react-redux';
import history from '../../../core/history';
import {
  getFirstProfileFromAccountSummary,
  getProfileFromAccountSummary,
} from '../../../core/util/account';
import { Routes } from '../../../core/login';

/**
 * ! WARNING: THIS HOOK WILL ROUTE YOU AWAY FROM THE CURRENT PAGE
 * ! UNEXPECTEDLY IF THE USER PROFILE IS NULL OR IN AN UNEXPECTED
 * ! STATE.
 *
 * @deprecated THIS HOOK HAS SIDE UNEXPECTED SIDE EFFECTS.
 * @returns a user profile
 */
function useSelectUserProfile(userProfileId?: string) {
  const accountSummary = useSelector((state: any) => state.account?.summary);

  const userProfile = useSelector(
    (state: any) =>
      getProfileFromAccountSummary(state.account?.summary, userProfileId) ||
      getFirstProfileFromAccountSummary(state.account.summary)
  );

  if (!accountSummary || !userProfileId) return null;

  if (!userProfile) {
    history.push(Routes.ACCOUNT_PROFILE_CREATE);
  }

  // usually in the case of deletion while on the profile you're deleting
  if (userProfile && userProfile.user_profile_id !== userProfileId) {
    history.push(`/account/home/${userProfile.user_profile_id}`);
  }

  return userProfile;
}

export default useSelectUserProfile;
